import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getStockMatchRedistributionExpiryPriorityLookup } from '../../../api/StockMatch';
import { useFetch } from '../../../services/transports';
import { LabeledSelect } from '../Input/LabeledSelect';

const ExpiryPrioritySelect = ({ allowClear = true, ...props }) => {
  const [ t, i18n ] = useTranslation();
  const [ { data }, fetchLookup ] = useFetch(
    getStockMatchRedistributionExpiryPriorityLookup,
    useCallback(response => response?.data?.container || [], [])
  );

  useEffect(() => {
    fetchLookup();
  }, [ i18n.language ]);

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      allowClear={ allowClear }
      options={ [
        { value: 'all', text: t('fields.expiryPriorityOptions.all') },
        ...(data || []).map(item => ({
          value: `${item.id}`,
          text: item.name
        }))
      ] }
    />
  );
};

export default ExpiryPrioritySelect;
